const methods = [
    'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
    'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
    'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
    'timeStamp', 'trace', 'warn'
];

const noop = () => {};

/**
 * Avoid console errors in browsers that lack a console.
 * http://stackoverflow.com/questions/3326650/console-is-undefined-error-for-internet-explorer - "taken from twitter's source code"
 */
export default function consolePolyfill() {
    const console = (window.console = window.console || {});

    let length = methods.length;
    while (length--) {
        const method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}
